import axios from "axios";

const BASE = process.env.REACT_APP_BACKEND_URL;
export const API = `${BASE}/api`;

const api = axios.create({ baseURL: API, withCredentials: false });

api.interceptors.request.use((cfg) => {
  const token = localStorage.getItem("sns_token");
  if (token) cfg.headers.Authorization = `Bearer ${token}`;
  return cfg;
});

api.interceptors.response.use(
  (r) => r,
  (e) => {
    const status = e?.response?.status;
    const detail = e?.response?.data?.detail || "";
    const isAuthError =
      status === 401 ||
      (status === 403 && /usuario desactivado/i.test(detail));
    if (status === 402 && e?.response?.data?.detail?.code === "trial_expired") {
      window.dispatchEvent(new Event("sns:trial-expired"));
    }
    if (isAuthError && window.location.pathname !== "/login") {
      localStorage.removeItem("sns_token");
      localStorage.removeItem("sns_user");
      window.location.href = "/login?desactivado=1";
    }
    return Promise.reject(e);
  }
);

export const fmtErr = (e) => {
  const d = e?.response?.data?.detail;
  if (!d) return e?.message || "Ha ocurrido un error";
  if (typeof d === "string") return d;
  if (Array.isArray(d)) return d.map((x) => x?.msg || JSON.stringify(x)).join(" · ");
  if (typeof d === "object" && d.message) return d.message;
  return String(d);
};

/** Detecta si un error viene del sistema de plan (402 Payment Required). */
export const isPlanLimitError = (e) => e?.response?.status === 402;

export default api;
